const { Core, Utils, Events } = Global;
const { $loading } = Utils;

customElements.define('cart-drawer', class extends Core {
    elements = {
        'modal': 'modal-container'
    }

    render() {
        this.sub(Events.CART_UPDATE, this._handleAddingToCart, { global: true });
        this.sub(Events.CART_CHANGE, this._handleCartChange, { global: true });
        this.sub(Events.CART_REPLACE, this._handleCartChange, { global: true });
        this.sub(Events.CART_DRAWER_MUTE, this._handleMute, { once: true, global: true });
        this.sub(Events.CART_ERROR, this._handleCartError, { global: true });
 
        $(document).off("click", "cart-qty").on("click", "cart-qty", async function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const $element = $(this);
            const itemKey = $element.attr('key');
            const newValue = parseInt($element.attr('value'), 10);
            
            if ($element.hasClass('processing') || isNaN(newValue)) {
                return;
            }
            
            $element.addClass('processing');
            
            const productContainer = $element.closest('[data-item-key]')[0] || 
                                $element.closest('.\\#cart-drawer-product')[0];
            
            console.log('Quantity change requested:', { itemKey, newValue });
            
            try {
                if (productContainer) {
                    $loading(productContainer, true);
                }
                $element.addClass('loading').attr('disabled', 'disabled');
                
                const updateResponse = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        id: itemKey,
                        quantity: newValue
                    })
                });
                
                if (!updateResponse.ok) {
                    throw new Error('Cart update failed');
                }
                
                setTimeout(async () => {
                    try {
                        if (typeof window.debouncedPriceUpdate === 'function') {
                            await window.debouncedPriceUpdate();
                        } else if (typeof window.updateCartPrices === 'function') {
                            await window.updateCartPrices();
                        }
                    } catch (priceError) {
                        console.error('Price update failed:', priceError);
                    } finally {
                        if (productContainer) {
                            $loading(productContainer, false);
                        }
                        $element.removeClass('loading processing').removeAttr('disabled');
                    }
                }, 200);
                
            } catch (error) {
                console.error('Cart quantity update failed:', error);
                
                if (productContainer) {
                    $loading(productContainer, false);
                }
                $element.removeClass('loading processing').removeAttr('disabled');
                
                alert('Unable to update quantity. Please try again.');
            }
        });

        // Clear input value on focus to make it easier to type a new quantity
        $(document).off("focus", ".\\#cart-drawer-quantity-controls-input, .cart-drawer-quantity-controls-input").on("focus", ".\\#cart-drawer-quantity-controls-input, .cart-drawer-quantity-controls-input", function() {
            const $input = $(this);
            // Store the original value if not already stored
            if (!$input.data('original-value')) {
                $input.data('original-value', $input.val());
            }
            // Clear the input value for easier editing
            $input.val('');
        });

        // Prevent form submission when Enter is pressed in quantity input field
        $(document).off("keydown", ".\\#cart-drawer-quantity-controls-input, .cart-drawer-quantity-controls-input").on("keydown", ".\\#cart-drawer-quantity-controls-input, .cart-drawer-quantity-controls-input", function(e) {
            // Prevent form submission on Enter key
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                e.stopPropagation();
                // Trigger blur to update the quantity
                $(this).blur();
                return false;
            }
        });

        // Handle blur event on quantity input field - uses same logic as cart-qty
        const self = this; // Capture cart-drawer instance
        $(document).off("blur", ".\\#cart-drawer-quantity-controls-input, .cart-drawer-quantity-controls-input").on("blur", ".\\#cart-drawer-quantity-controls-input, .cart-drawer-quantity-controls-input", function(e) {
            const $input = $(this);
            const itemKey = $input.data('item-key') || $input.attr('data-item-key');
            const line = $input.data('line') || parseInt($input.attr('data-line'), 10);
            
            if (!itemKey || isNaN(line)) {
                return;
            }

            // Validate the input value using the same logic as cart-qty's _getValidatedValue
            const maxValue = e.target.hasAttribute('max') && +e.target.getAttribute('max');
            const minValue = e.target.hasAttribute('data-minValue') && +e.target.getAttribute('data-minValue');
            const step = e.target.hasAttribute('step') && +e.target.getAttribute('step');
            let newValue = parseInt(e.target.value, 10);

            if (isNaN(newValue) || e.target.value === '') {
                // Reset to original value if invalid or empty
                const originalValue = parseInt($input.data('original-value') || $input.attr('value'), 10) || 0;
                e.target.value = originalValue;
                $input.removeData('original-value'); // Clean up stored value
                return;
            }

            // Apply validation logic (exact same as _getValidatedValue in cart-provider.js)
            if (maxValue && newValue > maxValue) {
                e.target.value = maxValue;
                newValue = maxValue;
            } else if (minValue && newValue < minValue) {
                e.target.value = 0;
                newValue = 0;
            } else if (step && newValue % step !== 0) {
                newValue = Math.ceil(newValue / step) * step;
                e.target.value = newValue;
            }

            // Don't update if value hasn't changed from the original
            const storedOriginalValue = $input.data('original-value');
            const originalValue = storedOriginalValue ? parseInt(storedOriginalValue, 10) : (parseInt($input.attr('value'), 10) || 0);
            if (newValue === originalValue) {
                $input.removeData('original-value'); // Clean up stored value
                return;
            }

            // Update the value attribute to reflect the new quantity
            $input.attr('value', newValue);
            $input.removeData('original-value'); // Clean up stored original value
            
            // Publish CART_CHANGE event exactly like cart-qty does - this triggers:
            // 1. cart-provider to update the cart
            // 2. cart-loader to show loading state (!loading class)
            // 3. cart-drawer to handle price updates
            self.pub(Events.CART_CHANGE, {
                key: itemKey,
                line: line,
                quantity: newValue
            });
        });

        window.updateCartPrices = (function(){
            let inFlight = null;
            return async function(qtyOverrides = {}) {
            if (inFlight) return inFlight;

            inFlight = (async () => {
                try {
                    console.log('Starting price update...');
                    
                    const cartResp = await fetch('/cart.js', { cache: 'no-store' });
                    if (!cartResp.ok) {
                        console.warn('Failed to fetch /cart.js', cartResp.status);
                        return;
                    }
                    const cart = await cartResp.json();

                    const itemsByKey = new Map();
                    cart.items.forEach(item => {
                        if (item.key) itemsByKey.set(item.key, item);
                    });

                    const productElements = document.querySelectorAll('.\\#cart-drawer-product, .cart-drawer-product');
                    if (!productElements || productElements.length === 0) {
                        console.log('No product elements found');
                        return;
                    }

                    const skuToItemKeys = new Map();
                    const keyToDomEl = new Map();

                    productElements.forEach(el => {
                        const itemKey = el.getAttribute('data-item-key') || el.dataset.itemKey;
                        let cartItem = itemKey && itemsByKey.has(itemKey) ? itemsByKey.get(itemKey) : null;

                        let sku = '';
                        if (cartItem) {
                            sku = cartItem.sku || '';
                        } else {
                            const img = el.querySelector('img');
                            if (img && img.getAttribute('src')) {
                                const filename = img.getAttribute('src').split('/').pop() || '';
                                sku = filename.split('_')[0] || '';
                            }
                        }

                        const finalQty = cartItem ? cartItem.quantity : 0;
                        if (!sku || finalQty === 0) return;

                        if (itemKey) keyToDomEl.set(itemKey, el);

                        if (!skuToItemKeys.has(sku)) skuToItemKeys.set(sku, []);
                        skuToItemKeys.get(sku).push({ key: itemKey, qty: finalQty, cartItem });


                    });

                    console.log('SKU mappings:', skuToItemKeys);

                    const skuPrices = new Map();
                    const ajaxPromises = [];

                    for (const [sku, entries] of skuToItemKeys.entries()) {
                        const maxQty = entries.reduce((m, e) => Math.max(m, e.qty || 0), 0);

                        const encodedValues = encodeURIComponent(JSON.stringify({
                            skuAndDomainName: {
                                productSKU: [sku],
                                domainName: "ace-products-group.myshopify.com",
                                tag: window.productTag,
                                NSID: window.productNSID
                            }
                        }));

                        const p = new Promise((resolve) => {
                            $.ajax({
                                type: 'GET',
                                url: "https://hooks.webbeeglobal.com/NetsuiteSuitetalkWeb/quantity-pricing/product",
                                dataType: 'json',
                                cache: false,
                                data: encodedValues,
                                success: function (data) {
                                    try {
                                        const jsonData = JSON.parse(JSON.stringify(data));
                                        if (jsonData['productValues'] && jsonData['productValues'] !== "null") {
                                            const responseJSON = JSON.parse(jsonData['productValues']);
                                            const skuData = responseJSON[sku] || [];
                                            if (skuData && skuData.length) {
                                                let matched = null;
                                                for (let i = 0; i < skuData.length; i++) {
                                                    const row = skuData[i];
                                                    if (maxQty >= row.quantity_min && maxQty <= row.quantity_max) { 
                                                        matched = row; 
                                                        break; 
                                                    }
                                                }
                                                if (!matched && skuData.length) matched = skuData[skuData.length - 1];
                                                if (matched) {
                                                    skuPrices.set(sku, { unit: parseFloat(matched.amount), raw: matched });
                                                    console.log(`Price found for SKU ${sku}:`, matched.amount);
                                                }
                                            }
                                        }
                                    } catch (err) {
                                        console.error('Quantity pricing parse error for SKU', sku, err);
                                    } finally {
                                        resolve();
                                    }
                                },
                                error: function () {
                                    console.error('Quantity pricing request failed for SKU', sku);
                                    resolve();
                                }
                            });
                        });
                        ajaxPromises.push(p);
                    }

                    await Promise.all(ajaxPromises);
                    console.log('All pricing requests completed:', skuPrices);

                    let computedSubtotal = 0;
                    for (const [sku, entries] of skuToItemKeys.entries()) {
                        const priceInfo = skuPrices.get(sku);
                        if (!priceInfo) continue;

                        const unitPrice = priceInfo.unit;

                        for (const entry of entries) {
                            const qty = entry.qty || 0;
                            const lineTotal = unitPrice * qty;
                            computedSubtotal += lineTotal;

                            const el = entry.key ? keyToDomEl.get(entry.key) : null;
                            if (el) {
                                const priceEl = el.querySelector('.\\#product-card-min-price, .product-card-min-price');
                                if (priceEl) {
                                    const newPrice = '$ ' + unitPrice.toFixed(2);
                                    if (priceEl.textContent !== newPrice) {
                                        priceEl.textContent = newPrice;
                                        priceEl.dataset.finalPrice = unitPrice.toFixed(2);
                                    }
                                }

                                const lineTotalEl = el.querySelector('.cart-line-total, .\\#cart-line-total');
                                if (lineTotalEl) {
                                    lineTotalEl.textContent = '$ ' + lineTotal.toFixed(2);
                                }
                            }
                        }
                    }

                    const priceEls = document.querySelectorAll('.\\#cart-drawer-subtotal-item-price, .cart-drawer-subtotal-item-price');
                    let discount = 0;
                    if (priceEls && priceEls.length >= 2) {
                        const discountStr = priceEls[1].textContent.trim().replace(/[^0-9.-]+/g, '');
                        discount = parseFloat(discountStr) || 0;
                    }

                    if (priceEls && priceEls.length >= 1) {
                        priceEls[0].textContent = '$ ' + computedSubtotal.toFixed(2);
                    }
                    const finalSubtotalEl = (priceEls && priceEls.length === 3) ? priceEls[2] : (priceEls && priceEls[1]);
                    if (finalSubtotalEl) {
                        finalSubtotalEl.textContent = '$ ' + (computedSubtotal + discount).toFixed(2);
                    }

                    const checkoutTotalSpan = document.querySelector('.\\#cart_checkout .\\#cart-drawer-checkout-total, .cart-checkout-total, .\\#cart_checkout .cart-checkout-total');
                    if (checkoutTotalSpan) {
                        checkoutTotalSpan.textContent = '$ ' + (computedSubtotal + discount).toFixed(2);
                    }

                    console.log('Price update completed successfully. New subtotal:', computedSubtotal.toFixed(2));

                } catch (err) {
                    console.error('updateCartPrices error:', err);
                } finally {
                    inFlight = null;
                }
            })();

            return inFlight;
            };
            })();



    }  
    

    _handleAddingToCart({ req }) {
        if(req === 'cartAdd') {
            this.$('modal').open();
        }
    }
 
    _handleCartChange({ key }) {
    this.updatingProduct = this.querySelector(`[data-item-key="${key}"]`);
    if (!this.updatingProduct) {
        return;
    }

    if (typeof window.debouncedPriceUpdate === 'function') {
        window.debouncedPriceUpdate();
    } else if (typeof window.updateCartPrices === 'function') {
        setTimeout(() => {
            window.updateCartPrices();
        }, 100);
    }
}

    _handleMute() {
        this.unsub(Events.CART_UPDATE);
    }

    _handleCartError() {
        this.updatingProduct && $loading(this.updatingProduct, false);
        $(document).find('cart-qty.loading').removeClass('loading').removeAttr('disabled');
    }
})